import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import useDataStore from '@/services/dataStore/useDataStore'
import { IRemedyCategory, RemedyCategorySchema } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetRemedyCategories = () => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function fetchRemedyCategories(
    dataStore: IDataStore
  ): Promise<IRemedyCategory[]> {
    try {
      const response = await dataStore.getRemedyCategories()

      const validation = z.array(RemedyCategorySchema).safeParse(response)
      let remedyCategories: IRemedyCategory[] = validation.data ?? []
      if (!validation.success) {
        remedyCategories = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return remedyCategories
    } catch (e) {
      handleDataStoreError(e)
      return []
    }
  }

  const result = useSWRV(
    () => `/remedyCategory/${dataStoreSWRVKey.value.perspective}`,
    async () => {
      return await fetchRemedyCategories(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000
    }
  )
  return result
}

export { useGetRemedyCategories }
